import React from 'react';
import { Message } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <Message negative>
      <Message.Header>{t('not_found.title')}</Message.Header>
      <p>{t('not_found.description')}</p>
      <p style={{ marginTop: '0.75em', opacity: 0.92 }}>
        {t('not_found.description_zh')}
      </p>
    </Message>
  );
};

export default NotFound;
